module.exports = __webpack_public_path__ + "static/media/oops.45c56a4c.gif";